<template>
  <div class="authorize-gate">
    <form @submit.prevent="authorize">
      <div class="authorize-field">
        <span class="lock-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="20"
            viewBox="0 0 21 20"
            fill="none"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5.25039 9V7C5.25039 4.23858 7.60089 2 10.5004 2C13.3999 2 15.7504 4.23858 15.7504 7V9C16.9102 9 17.8504 9.89543 17.8504 11V16C17.8504 17.1046 16.9102 18 15.7504 18H5.25039C4.09059 18 3.15039 17.1046 3.15039 16V11C3.15039 9.89543 4.09059 9 5.25039 9ZM13.6504 7V9H7.35039V7C7.35039 5.34315 8.76069 4 10.5004 4C12.2401 4 13.6504 5.34315 13.6504 7Z"
              fill="#204080"
            />
          </svg>
        </span>

        <input
          v-model="password"
          :type="show ? 'text' : 'password'"
          placeholder="Password"
          autocomplete="off"
          maxlength="1000"
          name="password"
          class="authorize-input"
        />

        <span class="eye-icon" @click="show = !show">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="20"
            viewBox="0 0 21 20"
            fill="none"
          >
            <path
              d="M10.4998 12C11.6596 12 12.5998 11.1046 12.5998 10C12.5998 8.89543 11.6596 8 10.4998 8C9.34 8 8.3998 8.89543 8.3998 10C8.3998 11.1046 9.34 12 10.4998 12Z"
              fill="#1C3756"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0.480469 10C1.81843 5.94291 5.79823 3 10.4998 3C15.2013 3 19.181 5.94288 20.519 9.99996C19.1811 14.0571 15.2013 17 10.4997 17C5.79824 17 1.81845 14.0571 0.480469 10ZM14.6998 10C14.6998 12.2091 12.8194 14 10.4998 14C8.18021 14 6.29981 12.2091 6.29981 10C6.29981 7.79086 8.18021 6 10.4998 6C12.8194 6 14.6998 7.79086 14.6998 10Z"
              fill="#1C3756"
            />
          </svg>
        </span>
      </div>

      <button type="submit" class="authorize-submit">Submit</button>
    </form>
  </div>
</template>

<script>
import { AUTHORIZE_KEY, setSiteAuthorized } from "@/auth/utils";
import useToastHandler from "@/services/toastHandler";

export default {
  data() {
    return {
      password: "",
      show: false,
    };
  },
  methods: {
    authorize() {
      if (this.password === AUTHORIZE_KEY) {
        setSiteAuthorized();
        this.$router.replace({ path: "/" });
      } else {
        this.showToastError("Invalid Authorize Key");
      }
    },
  },
  setup() {
    const { showToastError } = useToastHandler();
    return { showToastError };
  },
};
</script>

<style lang="scss" scoped>
.authorize-gate {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 1rem;
  background: #fff;
}

.authorize-field {
  position: relative;
  width: 320px;
  max-width: 100%;
}

.lock-icon,
.eye-icon {
  position: absolute;
  z-index: 10;
  top: 50%;
  transform: translateY(-50%);
  line-height: 0;
}

.lock-icon {
  left: 15px;
}

.eye-icon {
  right: 15px;
  cursor: pointer;
}

.authorize-input {
  width: 100%;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  outline: none;
  padding: 17px 40px 17px 50px;
}

.authorize-submit {
  display: block;
  margin: 16px auto 0;
  padding: 9px 24px;
  border: none;
  border-radius: 7px;
  background: #204080;
  color: #fff;
  font-weight: 600;
  transition: background 0.3s ease-in-out;
}

.authorize-submit:hover {
  background: #16305f;
}
</style>
